<template>
  <div>
    <el-dialog
      title="版本备注"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="c-content">{{ content || '无' }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="visible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      content: '无'
    }
  },
  methods: {
    init(info) {
      this.visible = true
      this.content = info.note
    }
  }
}
</script>

<style lang="scss" scoped>
//版本备注内容样式不管用
// .c-content{
//   .el-dialog__body{
//     margin-top: -18px !important;
//     margin-left: 18px !important;

//   }

// }
</style>
